import CashDetails from "./CashDetails";

export default CashDetails;
